<template>
    <div class="modalDeleteCalendarContainer">
        <p>¿Desea eliminar el periodo y sus programas?</p>
        <div>
            <button @click="buttonYes">Si</button>
            <button @click="buttonNo">No</button>
        </div>
    </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
    export default{
        props:{
            IdCalendarForDelete: Number,
        },
        data(){
            return{
                idCalendarForDelete: this.IdCalendarForDelete,
            }
        },
        methods:{
            buttonNo(){
                this.$emit('closeCalendarDeleteModal');
            },
            buttonYes(){
                IberoHelpers.DeleteProgramsForCalendar(this.$store, this.idCalendarForDelete);
                this.$emit('closeCalendarDeleteModalForYes');
            }
        }
    }
</script>
<style scoped>

    .modalDeleteCalendarContainer{
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center; 
        width: 30rem;
        height: 15rem;
        background-color: #fff;
        padding: 2rem;
    }

    .modalDeleteCalendarContainer p{
        font-size: 1.5rem;
    }

    .modalDeleteCalendarContainer div{
        display: flex;
        padding: 0 4rem;
        justify-content: space-between;
    }

    .modalDeleteCalendarContainer button{
        background-color: #d0ab4b;
        width: 5rem;
        height: 3rem;
        color: white;
        border: none;
        font-size: 1rem;
        padding: 0.3rem 1rem;
        border-radius: 0.3rem;
    }

</style>